import { render, staticRenderFns } from "./userMsgKp.vue?vue&type=template&id=365102a2&scoped=true"
import script from "./userMsgKp.vue?vue&type=script&lang=js"
export * from "./userMsgKp.vue?vue&type=script&lang=js"
import style0 from "./userMsgKp.vue?vue&type=style&index=0&id=365102a2&prod&lang=scss"
import style1 from "./userMsgKp.vue?vue&type=style&index=1&id=365102a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365102a2",
  null
  
)

export default component.exports